import React from 'react';
import { Info } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import ZoomBrandLogo from 'images/zoom_brand_logo.png';
import { getErrorMessage } from 'components/InPersonTraining/shared/Error';

const ZoomAttendanceTrackingInfo = ({
  currentUser,
  session,
  totalInvitees,
  onTakeAttendance,
  isFetchingAttendance,
  attendanceFetchError: error,
}) => {
  if (error) {
    return (
      <div className="d-f ai-c">
        <Info className="mr-8 llui-text-instrux-error" size={16} />
        <Text variant={TEXT_VARIANTS.INSTRUX_ERROR}>
          {getErrorMessage(error)}
        </Text>
        <button
          type="button"
          className="u-linkBtn ml-4 fz-16 fw-n"
          onClick={onTakeAttendance}
        >
          {t('common.retry')}
        </button>
      </div>
    );
  }

  const { video_meeting: videoMeeting } = session;
  const hasInvitees = totalInvitees !== 0;
  const videoMeetingAttendanceTaken = videoMeeting.attendance_taken;
  const sessionEnded = session.session_ended;
  const isVideoMeetingHost = videoMeeting.host_id === currentUser.id;
  return (
    <div className="d-f ai-c">
      <img
        src={ZoomBrandLogo}
        width="21"
        alt={t('in_person_training.events.zoom_logo')}
      />
      <Text variant={TEXT_VARIANTS.SUBHEADER} className="ml-8">
        {videoMeetingAttendanceTaken &&
          t('in_person_training.event_overview.session.zoom.matching_guests', {
            total_attendees: videoMeeting.total_attendees,
            total_invitees: totalInvitees,
          })}

        {sessionEnded &&
          hasInvitees &&
          !videoMeetingAttendanceTaken &&
          t(
            'in_person_training.event_overview.session.zoom.attendance_tracking_pending',
          )}

        {((sessionEnded && !hasInvitees && !videoMeetingAttendanceTaken) ||
          (!sessionEnded && !videoMeetingAttendanceTaken)) &&
          t(
            'in_person_training.event_overview.session.zoom.attendance_tracking_enabled',
          )}
      </Text>
      {(videoMeetingAttendanceTaken ||
        (sessionEnded && !hasInvitees && !videoMeetingAttendanceTaken) ||
        (!sessionEnded && !videoMeetingAttendanceTaken)) && (
        <span
          className="ml-8 mt-4 fz-12 radio-tooltip"
          data-toggle="tooltip"
          data-placement="top"
          title={t(
            'in_person_training.event_overview.session.zoom.attendance_tracking_tooltip',
          )}
        >
          <Info size={15} color="#474745" />
        </span>
      )}
      {isVideoMeetingHost &&
        sessionEnded &&
        hasInvitees &&
        !videoMeetingAttendanceTaken &&
        !isFetchingAttendance && (
          <button
            type="button"
            className="u-linkBtn ml-8 fz-20 fw-n"
            onClick={onTakeAttendance}
          >
            {t('in_person_training.event_overview.attendance.fetch_attendance')}
          </button>
        )}
      {sessionEnded &&
        !videoMeetingAttendanceTaken &&
        isFetchingAttendance &&
        '...'}
    </div>
  );
};

export default ZoomAttendanceTrackingInfo;
